import ProjectsList from '~/projects_list';

new ProjectsList(); // eslint-disable-line no-new
